import { Navigate } from "react-router-dom";
import { useAccountStorage } from "../hooks/useAccountStorage";
import { landingForType } from "../utils/roles";

// RootRedirect : point d'entrée "/". Redirige vers l'accueil de l'espace correspondant au type
// de l'utilisateur connecté (admin -> /admin, éleveur -> /breeder, etc.). Sert aussi de cible
// commune : login et AuthRoute renvoient sur "/", et c'est ici que se fait l'aiguillage par type.
export const RootRedirect = () => {
  const { getAccountStorage } = useAccountStorage();
  const token = localStorage.getItem("accessToken");
  if (!token) return <Navigate to="/login" replace />;
  return <Navigate to={landingForType(getAccountStorage()?.type)} replace />;
};
